import React from 'react';
import { Card, Title, Subtitle, CardLink } from './partials';
export var KPI = function KPI(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    href = _ref.href;
  return React.createElement(Card, null, React.createElement(CardLink, {
    href: href
  }, React.createElement(Title, null, title), React.createElement(Subtitle, null, subtitle)));
};